import React from "react"
import { ChipWithIcons } from ".."

interface IShowMoreButtonProps {
  isHidden: boolean
  onClick: (status: boolean) => void
  labelOnHidden: JSX.Element | string
  labelOnDisplayed: JSX.Element | string
}

const ShowMoreButton = React.memo(({
  isHidden,
  labelOnHidden,
  labelOnDisplayed,
  onClick
}: IShowMoreButtonProps) => <ChipWithIcons onClick={() => onClick(!isHidden)} label={isHidden ? labelOnHidden : labelOnDisplayed} />)
export default ShowMoreButton
